module.exports = {"SEARCH_PLACEHOLDER":"Tìm kiếm...","SEARCH_FILTER_DEFAULT_TEXT":"Tất cả dự án"}